import { I18n } from "@assets/strings";
import React, { useState } from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { Description } from "@ui/components/containers/description";
import { PrimaryBold } from "@ui/components/containers/primary";
import { RadioButton } from "@ui/components/inputs/radio";
import { stack } from "@ui/components/layout";
import { LinkExternal } from "@ui/components/linkExternal";
import { ClosableModal } from "@ui/modals/closableModal";

const url_rule = "https://www.onemillionafricantalents.com/wp-content/uploads/2022/08/REGLEMENT_CHALLENGE_ENG-1.pdf";
interface OmatModalInoProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}

export const OmatModalIno: React.FC<OmatModalInoProps> = ({ close, ...htmlProps }) => {
	const [rules, setRules] = useState<{ challengeRule: boolean; conditionRule: boolean }>({
		challengeRule: false,
		conditionRule: false,
	});
	const history = useHistory();
	return (
		<Container close={close} title={I18n.t("program.poppin.basics.label")} {...htmlProps}>
			<InfoBloc>
				<Bloc>
					<PrimaryBold>{I18n.t("program.poppin.eligible.label")}</PrimaryBold>
					<Description>{I18n.t("program.poppin.eligible.description")}</Description>
					<StyledList>
						<StyledUl>
							<li>{I18n.t("program.poppin.eligible.l1")}</li>
						</StyledUl>
						<StyledUl>
							<li>{I18n.t("program.poppin.eligible.l2")}</li>
						</StyledUl>
						<StyledUl>
							<li>{I18n.t("program.poppin.eligible.l3")}</li>
						</StyledUl>
					</StyledList>
				</Bloc>
				<Bloc>
					<PrimaryBold>{I18n.t("program.poppin.basics.label")}</PrimaryBold>
					<Description>{I18n.t("program.poppin.basics.description")} </Description>
					<StyledList>
						<StyledUl>
							<li>{I18n.t("program.poppin.basics.l1")}</li>
						</StyledUl>
						<StyledUl>
							<li>{I18n.t("program.poppin.basics.l2")}</li>
						</StyledUl>
						<StyledUl>
							<li>{I18n.t("program.poppin.basics.l3")}</li>
						</StyledUl>
						<StyledUl>
							<li>
								<li>{I18n.t("program.poppin.basics.l4")}</li>
							</li>
						</StyledUl>
					</StyledList>
				</Bloc>
				<Bloc>
					<PrimaryBold>{I18n.t("program.poppin.reminder.label")}</PrimaryBold>
					<Description>{I18n.t("program.poppin.reminder.description")}</Description>
				</Bloc>
				<Bloc>
					<StyledOmatRule>
						<RadioButton
							checkbox
							id="challenge"
							name="challenge_button"
							checked={rules.challengeRule}
							onChange={() => setRules((rules) => ({ ...rules, challengeRule: !rules.challengeRule }))}
						/>
						<StyledLabelRule>
							{I18n.t("program.poppin.rules.label1")}
							<LinkExternal to={url_rule}>
								<StyledRuleChalengeText>
									<b>{I18n.t("program.poppin.rules.label2")}</b>
								</StyledRuleChalengeText>
							</LinkExternal>
						</StyledLabelRule>
					</StyledOmatRule>
					<RadioButton
						checkbox
						label={I18n.t("program.poppin.news.label")}
						id="condition"
						name="condition_button"
						checked={rules.conditionRule}
						onChange={() => setRules((rules) => ({ ...rules, conditionRule: !rules.conditionRule }))}
					/>
				</Bloc>
			</InfoBloc>
			<ActionBloc>
				<PrimaryButton
					onClick={() => history.push(Path.ApplicationEditor("new", "OMAT"))}
					disabled={!rules.conditionRule || !rules.challengeRule}
				>
					{I18n.t("application.button.start_title")}
				</PrimaryButton>
			</ActionBloc>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	position: relative;
`;

const InfoBloc = styled.div`
	margin-top: 30px;
	display: flex;
	${stack(20)}
`;

const ActionBloc = styled.div`
	margin-top: 10px;
	display: flex;
	width: 100%;
	gap: 10px;
	flex-direction: column;
	align-items: center;
`;

const Bloc = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledList = styled(Description)`
	margin-left: 20px;
`;

const StyledUl = styled.ul`
	margin-bottom: 10px;
`;

const StyledOmatRule = styled.div`
	display: flex;
	flex-direction: row;
`;

const StyledLabelRule = styled.div`
	display: flex;
	flex-direction: row;
	margin-left: 10px;
`;
const StyledRuleChalengeText = styled.div`
	text-decoration: underline;
	cursor: pointer;
	margin-left: 4px;
`;
